import { render, staticRenderFns } from "./InfoData.vue?vue&type=template&id=6126b9ca&scoped=true"
import script from "./InfoData.vue?vue&type=script&lang=js"
export * from "./InfoData.vue?vue&type=script&lang=js"
import style0 from "./InfoData.vue?vue&type=style&index=0&id=6126b9ca&prod&lang=less&scoped=true"
import style1 from "./InfoData.vue?vue&type=style&index=1&id=6126b9ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126b9ca",
  null
  
)

export default component.exports